import defaultSettings from '../settings.json';
const initialState = {
  settings: defaultSettings,
  userInfo: {},
  nodeTreeNames: [],
  analysisInfo: {
    linePointCount: 30,
    maxTime: 7
  },
  nodeCount: 0
};
export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings':
      {
        const {
          settings
        } = action.payload;
        return {
          ...state,
          settings
        };
      }
    case 'update-userInfo':
      {
        const {
          userInfo
        } = action.payload;
        return {
          ...state,
          userInfo
        };
      }
    case 'update-nodeTreeNames':
      {
        const {
          nodeTreeNames
        } = action.payload;
        return {
          ...state,
          nodeTreeNames
        };
      }
    case 'update-nodeCount':
      {
        const {
          nodeCount
        } = action.payload;
        return {
          ...state,
          nodeCount
        };
      }
    case 'update-analysisInfo':
      {
        const {
          analysisInfo
        } = action.payload;
        return {
          ...state,
          analysisInfo
        };
      }
    default:
      return state;
  }
}